import React from "react";
import { ArticlePost } from "@/types/article";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";

interface EditorSEOProps {
  title: string;
  metaDescription: string;
  onSEODetailUpdate: (post: Partial<ArticlePost>) => void;
}

export const EditorSEO: React.FC<EditorSEOProps> = ({
  title,
  metaDescription,
  onSEODetailUpdate,
}) => {
  const handleTitleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onSEODetailUpdate({
      title: e.target.value,
      seoTitle: e.target.value,
    });
  };

  const handleMetaDescriptionChange = (
    e: React.ChangeEvent<HTMLTextAreaElement>,
  ) => {
    onSEODetailUpdate({
      seoDescription: e.target.value,
    });
  };

  return (
    <div className="flex flex-col h-full overflow-hidden">
      <div className="bg-white border-b border-gray-200 px-4 py-3 flex items-center justify-between sticky top-0 z-10">
        <h2 className="text-lg font-medium text-gray-900">SEO Settings</h2>
      </div>

      <div className="flex-1 overflow-auto p-4 max-w-4xl w-full">
        <div className="space-y-6">
          <div>
            <Label htmlFor="title" className="block text-sm mb-1">
              Title
            </Label>
            <Input
              type="text"
              id="title"
              value={title}
              onChange={handleTitleChange}
              className="w-full px-4 py-2"
              placeholder="Enter SEO title..."
            />
          </div>

          <div>
            <Label htmlFor="meta-description" className="block text-sm mb-1">
              Meta Description
            </Label>
            <Textarea
              id="meta-description"
              value={metaDescription}
              onChange={handleMetaDescriptionChange}
              rows={4}
              placeholder="Enter meta description..."
            />
          </div>
        </div>
      </div>
    </div>
  );
};
